<template>
  <!-- 充电订单 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="订单编号">
        <el-input placeholder="请输入订单编号" v-model="filter.ordernum" clearable></el-input>
      </el-form-item>
      <el-form-item label="用户昵称">
        <el-input placeholder="用户昵称" style="width: 120px" v-model="filter.nickName" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备号">
        <el-input placeholder="请输入设备号" v-model="filter.deviceid" clearable></el-input>
      </el-form-item>

      <el-form-item label="时间范围">
        <el-date-picker v-model="filter.dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select v-model="filter.send_start_mode" class="input" style="width: 100px" clearable placeholder="请选择订单类型">
          <el-option label="全部" value=""></el-option>
          <el-option label="普通充电" value="10"></el-option>
          <el-option label="预约充电" value="12"></el-option>
          <el-option label="智能托管" value="11"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <!-- <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button> -->
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="60" align="center"></el-table-column>
      <el-table-column label="用户昵称" prop="nickName" width="120" align="center"></el-table-column>
      <el-table-column label="设备号" prop="deviceid" width="120" align="center" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <div class="show_assets_code" @click="showTripletDetail(formatDeviceId(row.deviceid))">{{ row.deviceid }}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属站点" prop="address" width="120" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="订单金额" prop="OMoney" width="90" align="center"></el-table-column>
      <el-table-column label="预购电" prop="OMoney" width="95" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.ChargeTimeValue == 13">{{ "--" }}</span>
          <span style="color: #00b42a" v-else-if="row.ChargeTimeValue == 11"> {{ row.BuyNum }}度</span>
          <span type="info" style="font-size: 11px" v-else> --</span>
        </template>
      </el-table-column>
      <el-table-column label="用电量(度)" prop="totalElect" width="95" align="center"></el-table-column>

      <el-table-column label="订单编号" prop="ordernum" width="120" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="订单类型" prop="begin" width="180" align="center">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.begin == -1 || row.begin == ''">普通订单</el-tag>
          <el-tag type="info" style="font-size: 11px" v-else-if="row.begin == 1"> 智能托管</el-tag>
          <el-tag type="info" style="font-size: 11px" v-else> {{ row.return_boot_time_appomathod == 11 ? "已取消预约" : "预约订单" }} {{ row.begin }} </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="begin" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag type="info" v-if="row.return_boot_time_appomathod != 11 && row.dev_order == null">进行中</el-tag>
          <el-tag type="success" v-else> 已完成</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="退款状态" prop="IsReturn" align="center">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.IsReturn == true">已退款</el-tag>
          <el-tag type="info" v-else>未退款</el-tag>
        </template>
      </el-table-column> -->
      <el-table-column label="开始时间" prop="charge_start_time" align="center">
        <template slot-scope="{ row }">
          {{ row.return_boot_time_appomathod == 11 ? "" : row.charge_start_time }}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" prop="charge_end_time" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
      <el-table-column :label="$t('publics.operation')" width="180" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
          <el-button type="text" @click="editPowerCurve(row)" v-permision_tjtf="'gl_quxian'">功率曲线</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="充电详情" width="1250px" :close-on-click-modal="false">
      <el-row type="flex" justify="center" class="lower_formitem_box">
        <el-col :span="24">
          <el-form label-position="right" label-width="160px" :model="detailForm" ref="detailForm">
            <el-row :gutter="20">
              <!-- 第一列 -->
              <el-col :span="12">
                <el-form-item label="ID" prop="ID">
                  <el-input v-model="detailForm.ID" readonly disabled />
                </el-form-item>

                <el-form-item label="资产码" prop="deviceid">
                  <el-input v-model="detailForm.deviceid" readonly disabled />
                </el-form-item>

                <el-form-item label="订单金额" prop="OMoney">
                  <el-input v-model="detailForm.OMoney" readonly disabled />
                </el-form-item>

                <el-form-item label="订单编号" prop="ordernum">
                  <el-input v-model="detailForm.ordernum" readonly disabled />
                </el-form-item>

                <el-form-item label="预购电" prop="BuyNum">
                  <span v-if="detailForm.ChargeValue_Yuan == 13">{{ "--" }}</span>
                  <span v-else-if="detailForm.ChargeValue_Yuan == 11"> {{ detailForm.BuyNum }}度</span>
                </el-form-item>
                <el-form-item label="实际用电" prop="totalElect">
                  <el-input v-model="detailForm.totalElect" readonly disabled />
                </el-form-item>

                <el-form-item label="用户标识" prop="openid">
                  <el-input v-model="detailForm.openid" readonly disabled />
                </el-form-item>

                <el-form-item label="退款状态" prop="IsReturn">
                  <el-input v-model="detailForm.IsReturn" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="是否有序充电" prop="IsOrderly">
                  <el-input v-model="detailForm.IsOrderly" readonly disabled />
                </el-form-item> -->

                <el-form-item label="充电模式" prop="ChargeValue">
                  <el-input v-model="detailForm.ChargeValue" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="每小时/金额" prop="ChargeTimeValue">
                  <el-input v-model="detailForm.ChargeTimeValue" readonly disabled />
                </el-form-item> -->

                <!-- <el-form-item label="开始" prop="begin">
                  <el-input v-model="detailForm.begin" readonly disabled />
                </el-form-item> -->

                <!-- <el-form-item label="优惠券" prop="disCount">
                  <el-input v-model="detailForm.disCount" readonly disabled />
                </el-form-item> -->

                <el-form-item label="地址" prop="address">
                  <el-input v-model="detailForm.address" readonly disabled />
                </el-form-item>

                <el-form-item label="昵称" prop="nickName">
                  <el-input v-model="detailForm.nickName" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="创建时间" prop="createTime">
                  <el-input v-model="detailForm.createTime" readonly disabled />
                </el-form-item> -->

                <el-form-item label="聚能谷创建时间" prop="jng_create_time">
                  <el-input v-model="detailForm.jng_create_time" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="充电配置" prop="ChargingConfig">
                  <el-input v-model="detailForm.ChargingConfig" readonly disabled />
                </el-form-item> -->

                <!-- <el-form-item label="消息" prop="Topic">
                  <el-input v-model="detailForm.Topic" readonly disabled />
                </el-form-item>

                <el-form-item label="设备返回订单编号" prop="dev_return_tradeNo">
                  <el-input v-model="detailForm.dev_return_tradeNo" readonly disabled />
                </el-form-item> -->
              </el-col>

              <!-- 第二列 -->
              <el-col :span="12">
                <el-form-item label="创建时间" prop="create_time">
                  <el-input v-model="detailForm.create_time" readonly disabled />
                </el-form-item>

                <el-form-item label="修改时间" prop="modify_time">
                  <el-input v-model="detailForm.modify_time" readonly disabled />
                </el-form-item>
                <el-form-item label="启动充电时间" prop="dev_return_time">
                  <el-input v-model="detailForm.dev_return_time" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="是否删除" prop="del">
                  <el-input v-model="detailForm.del" readonly disabled />
                </el-form-item> -->

                <el-form-item label="启动类型" prop="send_start_type">
                  <el-input v-model="detailForm.send_start_type" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="充电模式" prop="send_start_charge_mode">
                  <el-input v-model="detailForm.send_start_charge_mode" readonly disabled />
                </el-form-item> -->

                <el-form-item label="启动模式" prop="send_start_mode">
                  <el-input v-model="detailForm.send_start_mode" readonly disabled />
                </el-form-item>

                <el-form-item label="启动时间" prop="send_start_time">
                  <el-tag type="success" v-if="detailForm.begin == -1">普通订单 {{ detailForm.send_start_time }}</el-tag>
                  <el-tag type="info" style="font-size: 11px" v-else-if="detailForm.begin == 1"> 智能托管</el-tag>
                  <el-tag type="info" style="font-size: 11px" v-else> {{ detailForm.return_boot_time_appomathod == 11 ? "已取消预约" : "预约订单" }} {{ detailForm.begin }} </el-tag>
                </el-form-item>

                <el-form-item label="启动结果" prop="return_start_result">
                  <el-input v-model="detailForm.return_start_result" readonly disabled />
                </el-form-item>

                <!-- <el-form-item label="启动故障代码" prop="return_start_fault_code">
                  <el-input v-model="detailForm.return_start_fault_code" readonly disabled />
                </el-form-item> -->

                <el-form-item label="下发停止指令时间" prop="send_stop_time">
                  <el-input v-model="detailForm.send_stop_time" readonly disabled />
                </el-form-item>

                <el-form-item label="停止原因" prop="send_stop_reason">
                  <el-input v-model="detailForm.send_stop_reason" readonly disabled />
                </el-form-item>

                <el-form-item label="停止结果" prop="return_stop_result">
                  <el-input v-model="detailForm.return_stop_result" readonly disabled />
                </el-form-item>

                <el-form-item label="停止失败原因" prop="return_stop_fail_res">
                  <el-input v-model="detailForm.return_stop_fail_res" readonly disabled />
                </el-form-item>
                <!-- 
                <el-form-item label="返回结果代码" prop="return_result_code">
                  <el-input v-model="detailForm.return_result_code" readonly disabled />
                </el-form-item> -->

                <el-form-item label="设备返回停止时间" prop="return_stop_time">
                  <el-input v-model="detailForm.return_stop_time" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <el-tabs type="border-card" style="margin-top: 20px" @tab-click="handleTabsClick" v-model="detailsActiveName" v-if="detailsActiveName">
            <el-tab-pane label="尖峰平谷电量电费详情" v-if="detailForm.electricityData" name="electricityFeeDetails">
              <el-table :data="electricityTableData" border size="medium" style="width: 100%; margin-bottom: 20px" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }">
                <el-table-column prop="period" label="时段" align="center" width="120"></el-table-column>
                <el-table-column prop="electricity" label="电量(度)" align="center">
                  <template slot-scope="{ row }">
                    <span :class="{ 'bold-text': row.period === '总计' }">{{ row.electricity }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="powerCost" label="电费(元)" align="center">
                  <template slot-scope="{ row }">
                    <span :class="{ 'bold-text': row.period === '总计' }">{{ row.powerCost }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="servCost" label="服务费(元)" align="center">
                  <template slot-scope="{ row }">
                    <span :class="{ 'bold-text': row.period === '总计' }">{{ row.servCost }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="智能托管订单充电计划" name="planSubOrder" v-if="orderDetailStartMode == 11">
              <el-table :data="autoCustodyPlanTableData" border size="medium" style="width: 100%; margin-bottom: 20px" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" highlight-current-row>
                <el-table-column prop="sub_ordernum" label="子订单编号" align="center" width="240"></el-table-column>
                <el-table-column prop="omoney" label="预计充电金额" align="center" width="110"></el-table-column>
                <el-table-column prop="real_money" label="实充金额" align="center" width="80">
                  <template slot-scope="{ row }">
                    <span>{{ formatReading(row.real_money / 10000) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="start_time" label="启动时间" align="center" width="155"></el-table-column>
                <el-table-column prop="is_finished" label="启动指令" align="center" width="90">
                  <template slot-scope="{ row }">
                    <el-tag type="info" v-if="row.start_time_send_id">已发送</el-tag>
                    <el-tag type="danger" v-else>未发送</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="end_time" label="结束时间" align="center" width="155"></el-table-column>
                <el-table-column prop="is_finished" label="结束指令" align="center" width="90">
                  <template slot-scope="{ row }">
                    <el-tag type="info" v-if="row.end_time_send_id">已发送</el-tag>
                    <el-tag type="danger" v-else>未发送</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="is_finished" label="状态" align="center" width="100">
                  <template slot-scope="{ row }">
                    <el-tag type="info" v-if="row.is_finished">已结束</el-tag>
                    <el-tag type="danger" v-else>未结束</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="is_finished" label="备注" align="center">
                  <template slot-scope="{ row }">
                    <span>{{ row.plat_reason }} , {{ row.dev_reason }}</span>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>

          <!-- 尖峰平谷电量电费表格 autoCustodyPlanTableData-->
          <!-- <div class="electricity-table-container" v-if="detailForm.electricityData">
            <h3 style="margin: 0px 0 10px 0; color: #409eff">尖峰平谷电量电费详情</h3>
            
          </div> -->
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 功率曲线组件 -->
    <power-order-curve :show.sync="visible.curve" :params="modelParams" @confirm="confirmpowercurve" class="detail-dialog"></power-order-curve>

    <tripletDetail ref="tripletDetail"></tripletDetail>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { GetDevChargeOrderPageList, getDevChargeOrderSubListApi } from "@/api/dev_data_view"
import powerordercurve from "./components/power-order-curve.vue"
import tripletDetail from "../control/_triplet_detail.vue"

import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { "power-order-curve": powerordercurve, fileUpload, tripletDetail },

  data() {
    return {
      detailForm: {
        electricityData: null // 存储电量电费数据
      },
      detailVisible: false,
      visible: {
        editGroup: false,
        curve: false
      },
      modelParams: {},

      tableData: [],
      filter: {
        send_start_mode: "", //<!-- 10：普通充电；11：有序充电12：预约充电 -->
        ordernum: "",
        deviceid: "",
        dateRange: [], // 使用一个数组来同时存储开始和结束时间
        nickName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "", //街道id
      detailsActiveName: undefined,
      orderDetailStartMode: 0,
      autoCustodyPlanTableData: []
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    // 计算表格数据
    electricityTableData() {
      if (!this.detailForm.electricityData) return []

      const data = this.detailForm.electricityData
      const tableData = [
        {
          period: "尖",
          electricity: data.sharpElect / 1000 || 0,
          powerCost: data.sharpPowerCost / 10000 || 0,
          servCost: data.sharpServCost / 10000 || 0,
          totalCost: (data.sharpPowerCost / 10000 || 0) + (data.sharpServCost / 10000 || 0)
        },
        {
          period: "峰",
          electricity: data.peakElect / 1000 || 0,
          powerCost: data.peakPowerCost / 10000 || 0,
          servCost: data.peakServCost / 10000 || 0,
          totalCost: (data.peakPowerCost / 10000 || 0) + (data.peakServCost / 10000 || 0)
        },
        {
          period: "平",
          electricity: data.flatElect / 1000 || 0,
          powerCost: data.flatPowerCost / 10000 || 0,
          servCost: data.flatServCost / 10000 || 0,
          totalCost: (data.flatPowerCost / 10000 || 0) + (data.flatServCost / 10000 || 0)
        },
        {
          period: "谷",
          electricity: data.valleyElect / 1000 || 0,
          powerCost: data.valleyPowerCost / 10000 || 0,
          servCost: data.valleyServCost / 10000 || 0,
          totalCost: (data.valleyPowerCost / 10000 || 0) + (data.valleyServCost / 10000 || 0)
        },
        {
          period: "总计",
          electricity: data.totalElect / 1000 || 0,
          powerCost: data.totalPowerCost / 10000 || 0,
          servCost: data.totalServCost / 10000 || 0,
          totalCost: (data.totalPowerCost / 10000 || 0) + (data.totalServCost / 10000 || 0)
        }
      ]

      return tableData
    }
  },
  created() {
    this.getData()
  },
  // watch: {
  //   detailsActiveName: {
  //     handler(newVal, oldVal) {
  //       console.log("detailsActiveName", newVal)
  //       if (newVal === "planSubOrder") {
  //         this.getDevChargeOrderSubList(this.detailForm.ordernum)
  //       }
  //     },
  //     immediate: true // 初始化立即执行
  //   }
  // },
  methods: {
    showTripletDetail(assetsCode) {
      this.$refs.tripletDetail.showTripletInfo(assetsCode)
    },
    // 搜索方法
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },
    /**
     * 格式化金额
     */
    formatReading(val) {
      if (val === null || val === undefined || val === "") return "0.0000"
      //return Number(val).toFixed(4).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return Number(val).toFixed(4)
    },

    // 格式化计费模式
    formatTimeDivType(val) {
      const map = {
        10: "尖峰平谷计费",
        20: "单一电价计费"
      }
      return map[val] || val || "--"
    },

    // 格式化设备ID，去掉后三位
    formatDeviceId(deviceid) {
      if (!deviceid || typeof deviceid !== "string") return deviceid || "--"
      if (deviceid.length <= 3) return deviceid
      return deviceid.substring(0, deviceid.length - 3)
    },
    // ==================== 枚举映射辅助函数 ====================
    // 是否删除映射
    formatDel(val) {
      if (val === true || val === "true" || val === 1) return "是"
      if (val === false || val === "false" || val === 0) return "否"
      return val || "--"
    },
    // 退款状态映射
    formatIsReturn(val) {
      if (val === true || val === "true" || val === 1) return "是"
      if (val === false || val === "false" || val === 0) return "否"
      return val || "--"
    },
    // 启动类型映射
    formatSendStartType(val) {
      const map = {
        10: "app一键启动",
        11: "即插即充",
        12: "蓝牙离线启动",
        13: "二维码启动",
        14: "桩侧扫码启动（桩自带识别器）",
        15: "平台启动"
      }
      const num = Number(val)
      return map[num] || val || "--"
    },
    // 充电 模式映射（用于 ChargeValue 和 send_start_charge_mode）
    formatChargeMode(val) {
      const map = {
        10: "不做限制的充电（默认）",
        11: "限制金额",
        12: "限制电量",
        13: "限制SOC",
        14: "限制充电时长"
      }
      const num = Number(val)
      return map[num] || val || "--"
    },
    // 启动模式映射
    formatSendStartMode(val) {
      const map = {
        10: "普通充电",
        11: "有序充电",
        12: "预约充电"
      }
      const num = Number(val)
      return map[num] || val || "--"
    },
    // 启动结果映射
    formatReturnStartResult(val) {
      const map = {
        10: "成功",
        11: "充电设备故障启动充电失败",
        12: "等待启动充电超时",
        13: "车桩连接失败",
        14: "正在充电中"
      }
      const num = Number(val)
      return map[num] || val || "--"
    },
    // 停止原因映射
    formatSendStopReason(val) {
      const map = {
        10: "用户主动停止",
        11: "余额不足",
        12: "预付金额消费完毕",
        13: "平台监测充电异常停机",
        14: "充电枪未在充电中"
      }
      const num = Number(val)
      return map[num] || val || "--"
    },
    // 停止结果映射
    formatReturnStopResult(val) {
      const map = {
        10: "成功",
        11: "失败"
      }
      const num = Number(val)
      return map[num] || val || "--"
    },
    // 停止失败原因映射
    formatReturnStopFailRes(val) {
      const map = {
        10: "--",
        11: "已停机"
      }
      const num = Number(val)
      return map[num] || val || "--"
    },
    onDetail(row) {
      this.orderDetailStartMode = row.send_start_mode
      this.autoCustodyPlanTableData = []
      // 深拷贝原始数据
      const formatted = { ...row }

      // 获取电量电费数据
      if (row.dev_order) {
        formatted.electricityData = {
          // 尖
          sharpElect: row.dev_order.sharpElect || 0,
          sharpPowerCost: row.dev_order.sharpPowerCost || 0,
          sharpServCost: row.dev_order.sharpServCost || 0,
          // 峰
          peakElect: row.dev_order.peakElect || 0,
          peakPowerCost: row.dev_order.peakPowerCost || 0,
          peakServCost: row.dev_order.peakServCost || 0,
          // 平
          flatElect: row.dev_order.flatElect || 0,
          flatPowerCost: row.dev_order.flatPowerCost || 0,
          flatServCost: row.dev_order.flatServCost || 0,
          // 谷
          valleyElect: row.dev_order.valleyElect || 0,
          valleyPowerCost: row.dev_order.valleyPowerCost || 0,
          valleyServCost: row.dev_order.valleyServCost || 0,
          // 总计
          totalElect: row.dev_order.totalElect || 0,
          totalPowerCost: row.dev_order.totalPowerCost || 0,
          totalServCost: row.dev_order.totalServCost || 0,
          // 其他信息
          timeDivType: row.dev_order.timeDivType,
          sumStart: row.dev_order.sumStart,
          sumEnd: row.dev_order.sumEnd
        }
        this.detailsActiveName = "electricityFeeDetails"
      } else {
        formatted.electricityData = null
        this.detailsActiveName = undefined
      }

      console.log(`start_mode = ${row.send_start_mode}`)
      if (row.send_start_mode == 11) {
        // 表示是智能托管有序充电模式订单
        if (!formatted.electricityData) {
          this.detailsActiveName = "planSubOrder"
          this.getDevChargeOrderSubList(formatted.ordernum)
        }
      }

      //console.log(`this.detailsActiveName = ${this.detailsActiveName}`)

      // 转换需要映射的字段
      formatted.del = this.formatDel(formatted.del)
      formatted.IsReturn = this.formatIsReturn(formatted.IsReturn)
      formatted.send_start_type = this.formatSendStartType(formatted.send_start_type)
      formatted.ChargeValue_Yuan = formatted.ChargeValue
      formatted.ChargeValue = this.formatChargeMode(formatted.ChargeValue)
      formatted.send_start_charge_mode = this.formatChargeMode(formatted.send_start_charge_mode)
      formatted.send_start_mode = this.formatSendStartMode(formatted.send_start_mode)
      formatted.return_start_result = this.formatReturnStartResult(formatted.return_start_result)
      formatted.send_stop_reason = row.dev_order ? row.dev_order.reason_desc || "--" : "--" //this.formatSendStopReason(formatted.send_stop_reason)
      formatted.return_stop_result = this.formatReturnStopResult(formatted.return_stop_result)
      formatted.return_stop_fail_res = this.formatReturnStopFailRes(formatted.return_stop_fail_res)

      this.detailForm = formatted
      this.detailVisible = true
    },
    handleTabsClick(tab, event) {
      console.log(tab, event)
      if (tab.name === "planSubOrder") {
        this.getDevChargeOrderSubList(this.detailForm.ordernum)
      }
    },
    editPowerCurve(row) {
      //let asset_code = this.formatDeviceId(row.deviceid)
      this.modelParams = {
        deviceid: row.deviceid,
        ordernum: row.ordernum,
        charge_start_time: row.charge_start_time,
        charge_end_time: row.charge_end_time
      }
      this.visible.curve = true
    },
    confirmpowercurve(item) {
      this.visible.curve = false
      this.detailForm.asset_code = item.asset_code
    },
    getData() {
      this.loading = true
      GetDevChargeOrderPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        deviceid: this.filter.deviceid,
        start_time: this.filter.dateRange.length == 0 ? "" : this.filter.dateRange[0],
        end_time: this.filter.dateRange.length == 0 ? "" : this.filter.dateRange[1],
        send_start_mode: this.filter.send_start_mode,
        ordernum: this.filter.ordernum,
        nickName: this.filter.nickName
      })
        .then((res) => {
          this.tableData = res.data
          this.tableData.forEach((element) => {
            console.log("element.dev_orderelement.dev_orderelement.dev_orderelement.dev_orderelement.dev_order", element.dev_order != null)
            if (element.dev_order != null) {
              element.totalElect = element.dev_order.totalElect / 1000
              element.charge_end_time = element.dev_order.charge_end_time
              element.charge_start_time = element.dev_order.charge_start_time
            } else {
              element.charge_start_time = element.jng_create_time
            }
          })
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    getDevChargeOrderSubList(orderNo) {
      let requestData = {
        orderNo: orderNo
      }
      getDevChargeOrderSubListApi(requestData).then((res) => {
        this.autoCustodyPlanTableData = res.data
      })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}

/* 去除详情对话框的内外边距 */
.detail-dialog ::v-deep .el-dialog {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

/* 确保表格容器没有额外间距 */
.my-pagination {
  margin-top: 20px;
  text-align: right;
}

/* 尖峰平谷表格样式 */
.electricity-table-container {
  margin-top: 10px;
  padding: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #f8f9fa;
}

.electricity-table-container h3 {
  text-align: center;
  font-weight: bold;
  padding-bottom: 10px;
  border-bottom: 2px solid #409eff;
}

/* 表格样式 */
.bold-text {
  font-weight: bold;
  font-size: 16px;
}

.red-text {
  color: #f56c6c;
}
</style>
